import { rootElement } from '@shared/setup';
import MainNavigation from './MainNavigation.vue';

const initMainNavigation = async () => {
    rootElement({
        name: 'MainNavigation', // pascal, camel & kebab-case are valid
        component: MainNavigation,
        vm: {},
        contextComponents: ['<div>Waiting...</div>'],
    });
};

initMainNavigation();
